import { INTRODUCTION_IS_SHOWN } from "../Actions/ActionIntroduction";

const inititalState = {
  isShown: false
};

export const introduction = (state = inititalState, action) => {
  switch (action.type) {
    case INTRODUCTION_IS_SHOWN:
      return {
        ...state,
        isShown: true
      };
    default:
      return state;

  }
};